export default {
  getOwners: state => state.owners,
  getCollectors: state => state.owners.filter(o => o.profile_type == 6),
  getCoffeshopOwners: state => state.owners.filter(o => o.profile_type == 3),
  getAvailableCollectors: state => id_collector => state.owners.filter(o => o.profile_type == 6 && (o.schools === false || id_collector.includes(o.id))),
  getAvailableStoreAdmins: state => id_owner => state.owners.filter(o => o.profile_type == 7 && (o.stores === false || id_owner.includes(o.id))),
  getAdminsByStoreId: state => id_store => state.owners.filter(o => o.profile_type == 7 && (o.stores && o.stores.some(s => s.id == id_store)))
}
